import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { routes } from './src/config/routes';
import { useAuthStore } from './src/store';

export default function App() {
  const { isLoggedIn, logout, login } = useAuthStore();

  const handleToggleAuth = () => {
    if (isLoggedIn) {
      logout();
    } else {
      login({
        id: '1',
        name: 'Usuario',
        email: 'usuario@mexmo.com',
        phone: '+52 123 456 7890',
      });
    }
  };

  return (
    <BrowserRouter>
      {/* Toast notifications */}
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: 'white',
            border: '1px solid #E5E7EB',
            borderRadius: '12px',
            padding: '12px 16px',
          },
          className: 'font-sans',
        }}
      />
      
      {/* Demo Toggle Button - Remove in production */}
      <div className="fixed top-4 right-4 z-[100]">
        <button
          onClick={handleToggleAuth}
          className="flex items-center gap-2 px-3 py-2 bg-[#111827]/80 backdrop-blur-sm text-white rounded-[10px] shadow-sm hover:bg-[#111827] transition-colors text-xs font-medium border border-white/10"
          title="Toggle login state (demo only)"
        >
          {isLoggedIn ? '🔓 In' : '🔒 Out'}
        </button>
      </div>

      {/* Application routes */}
      <Routes>
        {routes.map((route, index) => (
          <Route key={route.path || index} {...route} />
        ))}
      </Routes>
    </BrowserRouter>
  );
}